"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = exports.CellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cell_label_1 = require("./cell-label");
var badge_1 = require("./badge");
var router_1 = require("@reach/router");
var use_lang_1 = require("../../hooks/use-lang");
var ellipsis_button_1 = require("./ellipsis-button");
exports.CellDefaultProps = {
  isPending: false,
  labelVariant: 'normal',
  dotSize: 6,
  space: 0.75
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isLink = _a.isLink;
    return isLink && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visible;\n    }\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visible;\n    }\n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    min-height: 18px;\n    justify-content: flex-start;\n    align-items: center;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    min-height: 18px;\n    justify-content: flex-start;\n    align-items: center;\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LabelAndBadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n\n  "], ["\n    display: flex;\n    align-items: flex-start;\n\n  "])))
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    visibility: hidden;\n    padding: ", " ", ";\n  "], ["\n    visibility: hidden;\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.article(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""]))),
  Header: styled_components_1.default.header(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  LabelAndBadge: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelAndBadgeStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  MenuButton: (0, styled_components_1.default)(ellipsis_button_1.EllipsisButton)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles)
};
My.Container = styled_components_1.default.article(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ContainerStyles);
var Cell = function (props) {
  var className = props.className,
    label = props.label,
    badge = props.badge,
    isPending = props.isPending,
    labelVariant = props.labelVariant,
    children = props.children,
    to = props.to,
    menu = props.menu;
  var hasBadge = !!badge;
  var hasLabel = !!label;
  var hasHeader = hasLabel || hasBadge;
  // update this!
  var t = (0, use_lang_1.useLang)();
  var onClick = to ? function () {
    return (0, router_1.navigate)(to);
  } : function () {};
  return react_1.default.createElement(My.Container, {
    isLink: !!to,
    onClick: onClick,
    className: className
  }, hasHeader && react_1.default.createElement(My.Header, null, react_1.default.createElement(My.LabelAndBadge, null, hasLabel && react_1.default.createElement(My.Label, {
    variant: labelVariant
  }, t(label)), hasBadge && react_1.default.createElement(My.Badge, {
    isPending: isPending
  }, badge)), menu), children);
};
exports.Cell = Cell;
exports.Cell.defaultProps = exports.CellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;